import { render, staticRenderFns } from "./mobile-nav.vue?vue&type=template&id=c5f99840&scoped=true&"
import script from "./mobile-nav.vue?vue&type=script&lang=ts&"
export * from "./mobile-nav.vue?vue&type=script&lang=ts&"
import style0 from "./mobile-nav.vue?vue&type=style&index=0&id=c5f99840&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f99840",
  null
  
)

export default component.exports